/**
 * @file VariantObjArrayField.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Apr 08, 2022 17:57
 */
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import FormLabel from '@mui/material/FormLabel';
import { makeStyles } from '@mui/styles';

import VariantObjFieldContainer from 'src/components/fieldComponents/VariantObjField/VariantObjFieldContainer';

const useStyles = makeStyles(() => {
    return {
        formLabel: {
            marginTop: '20px',
            marginBottom: '15px',
            marginLeft: '15px',
        },
        textField: {
            marginTop: '3px',
            marginBottom: '10px',
            marginLeft: '0px',
            marginRight: '0px',
        },
    };
});

function VariantObjArrayField(props) {
    const {
        annotationType,
        fieldSchema,
        biocurations,
        variantObjArray,
        handleAdd,
        handleBlur = () => { },
        handleDelete,
        handleGDotLookup,
    } = props;

    const classes = useStyles();

    return (
        <Card variant="outlined" className="shadow-1 mt-10 mb-10" >

            <FormLabel className={classes.formLabel} component="legend">Variants</FormLabel>

            <CardActions style={{ justifyContent: 'flex-start', marginBottom: '10px', marginLeft: '0px' }}>

                <Button
                    variant="outlined"
                    color="success"
                    size="small"
                    sx={{ marginLeft: '15px', }}
                    onClick={(ev) => {
                        ev.preventDefault();
                        ev.stopPropagation();
                        handleAdd();
                    }}
                >
                    Add Variant
                </Button>

            </CardActions>

            {
                variantObjArray.map((variantObj, index) => {

                    return (<VariantObjFieldContainer
                        key={index}
                        annotationType={annotationType}
                        fieldSchema={fieldSchema}
                        biocurations={biocurations}
                        variantObj={variantObj}
                        isArrayElement={true}
                        handleBlur={handleBlur}
                        handleDelete={handleDelete}
                        handleGDotLookup={handleGDotLookup}
                    />)

                })
            }

        </Card>
    );
}

VariantObjArrayField.propTypes = {
    annotationType: PropTypes.string,
    fieldSchema: PropTypes.array.isRequired,
    biocurations: PropTypes.object,
    variantObjArray: PropTypes.array.isRequired,
    handleAdd: PropTypes.func.isRequired,
    handleBlur: PropTypes.func.isRequired,
    handleDelete: PropTypes.func.isRequired,
    handleGDotLookup: PropTypes.func.isRequired,
};

export default VariantObjArrayField;
